const hostname = window.location.hostname;
const isLocal = hostname === 'localhost';

const remoteHost = 'https://web.walkly.app';
const remoteBackend = 'https://api.walkly.app';
const localBackend = 'http://localhost:3000';

export const api = isLocal ? localBackend : remoteBackend;
export const host = isLocal ? localBackend : remoteHost;
